module.exports = "https://img1.huilianyi.com/7/quickly-create@2x.720cca1ff3.appcore.png";